import { normalizeProjectPathForComparison } from "./projectPaths";

export function joinGuidedProjectPath(root: string, slug: string): string {
  return `${root.replace(/\/+$/, "")}/${slug}`;
}

export function allocateUniqueGuidedProjectSlug<T extends { cwd: string }>(
  baseSlug: string,
  root: string,
  projects: ReadonlyArray<T>,
): string {
  const takenPaths = new Set(
    projects
      .map((project) => normalizeProjectPathForComparison(project.cwd))
      .filter((value) => value.length > 0),
  );

  for (let suffix = 1; suffix < 1_000; suffix += 1) {
    const candidate = suffix === 1 ? baseSlug : `${baseSlug}-${suffix}`;
    const candidatePath = normalizeProjectPathForComparison(joinGuidedProjectPath(root, candidate));
    if (!takenPaths.has(candidatePath)) {
      return candidate;
    }
  }

  return `${baseSlug}-${Date.now()}`;
}
